import { isEmpty } from "../helper/common";
import { showEmptyCartModal } from "../helper/showEmptyCartModal";
import { removeFormSubmitStatus } from "../helper/removeFormSubmitStatus";


const WatcherService = function (Cart, Discount, Config) {
    var service = {};

    service.factory = function ($scope) {

        var callsDiscount = false;
        var callUpdateDiscount = function () {

            if (callsDiscount) {
                return false;
            }
            callsDiscount = true;
            $scope.ajaxCall('cart', 'updatediscount', 'POST',
                {
                    updateDiscount: true,
                    discount: Discount.item,
                    shippingMethod: Cart.shippingMethod,
                    ticketFormat: Cart.ticketFormat,
                    paymentMethod: Cart.paymentMethod
                },
                function (response) {
                    callsDiscount = false;

                    if (response.voucherRemoved) {
                        $scope.removeVoucherFromCart();
                    }
                    if (response.voucherNotValid) {
                        $scope.displayError(response.voucherNotValid.error);
                        $scope.removeVoucherFromCart();
                    }
                    if (response.discount) {
                        Discount.setDiscount(response.discount, $scope);
                    }
                }
            );
        };
        var checkVariable = function (newValue, oldValue) {
            var resetValue = oldValue && !newValue;
            return (resetValue || newValue && (!oldValue || newValue[ 'id' ] !== oldValue[ 'id' ]));
        };
        var initWatcher = {
            ticketFormat: false,
            shippingMethod: false,
            paymentMethod: false
        };
        $scope.$watch('Cart.ticketFormat', function (newVal, oldVal) {
            if (!initWatcher.ticketFormat || checkVariable(newVal, oldVal)) {
                callUpdateDiscount();
                initWatcher.ticketFormat = true;
            }
        });
        $scope.$watch('Cart.shippingMethod', function (newVal, oldVal) {
            if (!initWatcher.shippingMethod || checkVariable(newVal, oldVal)) {
                callUpdateDiscount();
                initWatcher.shippingMethod = true;
            }
        });
        $scope.$watch('Cart.paymentMethod', function (newVal, oldVal) {
            if (!initWatcher.paymentMethod || checkVariable(newVal, oldVal)) {
                callUpdateDiscount();
                initWatcher.paymentMethod = true;
            }
        });

        $scope.$watch('formStatus', function (newValue, oldValue) {
            if (oldValue[ 'loginMode' ] === false && newValue[ 'loginMode' ] === true) {
                $scope.formStatus.registerMode = false;
                $scope.formStatus.updateMode = false;
                $scope.formStatus.userKnown = false;
            }
            if (oldValue[ 'registerMode' ] === false && newValue[ 'registerMode' ] === true) {
                $scope.formStatus.loginMode = false;
                $scope.formStatus.updateMode = false;
                $scope.formStatus.userNotKnown = false;
                $scope.formStatus.guestMode = false;
            }
            if (oldValue[ 'guestLoggedIn' ] === false && newValue[ 'guestLoggedIn' ] === true) {
                $scope.formStatus.userLoggedIn = false;
                $scope.checkCheckoutPossible();
                $scope.updateCheckoutOptions();
            }
            else if (oldValue[ 'guestLoggedIn' ] === true && newValue[ 'guestLoggedIn' ] === false) {
                removeFormSubmitStatus();

            }
            if (oldValue[ 'userLoggedIn' ] === false && newValue[ 'userLoggedIn' ] === true) {
                $scope.formStatus.guestLoggedIn = false;
                $scope.checkCheckoutPossible();
                $scope.updateCheckoutOptions();
            }
            else if (oldValue[ 'userLoggedIn' ] === true && newValue[ 'userLoggedIn' ] === false) {
                removeFormSubmitStatus();
            }
            if (oldValue[ 'updateMode' ] === false && newValue[ 'updateMode' ] === true) {
                $scope.formStatus.registerMode = false;
                $scope.formStatus.loginMode = false;
                $scope.checkCheckoutPossible();
            }
            if (oldValue[ 'updateMode' ] === true && newValue[ 'updateMode' ] === false) {
                $scope.checkCheckoutPossible();
            }
        }, true);

        $scope.$watch('cartItems', function (newValue, oldValue) {
            if (newValue === null || isEmpty(newValue)) {
                showEmptyCartModal();
            }
        });

        $scope.$watch('agbCheck', function (newValue, oldValue) {
            $scope.checkCheckoutPossible();
        });

        $scope.$watch('ticketsInCart', function (newValue, oldValue) {
            $scope.showClock = (newValue || ($scope.checkIfProductsInCart() && Config.config.carttimeouttype));
        });

    };
    return service;

};

export default WatcherService;